import { setFetchingState, loadSpaceSpecificUser, setFetchingStateGroup, loadSpaceSpecificGroups, loadSpaceSpecificUserPickers, setFetchingStateUserPicker } from "../slices/userRoleGroupSlice.js";
import axios from "axios";

export const fetchSpaceSpecificUsers = (data={}, reload=false) => {
    return (dispatch, getState) => {
        const { spaceId, userInfo } = data
        
        // Validate spaceId before making API call
        if (!spaceId || spaceId === 'undefined' || spaceId === undefined) {
            return dispatch(loadSpaceSpecificUser({data: []}));
        }
        
        const state = getState()
        const { userRoleGroupState } = state;
        if((userRoleGroupState && !userRoleGroupState.fetchingSpecificUser && (!userRoleGroupState.spaceSpecificUsers || userRoleGroupState.spaceSpecificUsers.length === 0)) || reload){
            dispatch(setFetchingState({fetchingSpecificUser: true}));
            let accessToken = localStorage.getItem("accessToken")

             try {
                axios({
                    method: "GET",
                    url: `${process.env.REACT_APP_BACKEND_API}/users`,
                    headers: {
                        Accept: "application/json",
                        userId: userInfo.userId,
                        tenantId: localStorage.getItem("tenantId"),
                        authorization: accessToken
                    },
                    params: {
                        spaceId,
                    },
                })
                .then(response => {
                    if(response.data?.result){
                        let filteredData = response.data.result.map((user) => {
                            return {
                              ...user,
                            //   role: user.userAccess?.filter(
                            //     (access) => access.resource === spaceId
                            //   )[0]?.role,
                            };
                        });
                        return dispatch(loadSpaceSpecificUser({data: filteredData}));
                    }
                })
            } catch (error) {
            }
        }
    };
}
export const fetchSpaceSpecificGroups = (data={}, reload=false) => {
    return (dispatch, getState) => {
        const { spaceId, userInfo } = data
        
        // Validate spaceId before making API call
        if (!spaceId || spaceId === 'undefined' || spaceId === undefined) {
            return dispatch(loadSpaceSpecificGroups({data: []}));
        }
        
        const state = getState()
        const { userRoleGroupState } = state;
        if((userRoleGroupState && !userRoleGroupState.fetchingSpecificGroups && (!userRoleGroupState.spaceSpecificGroups || userRoleGroupState.spaceSpecificGroups.length === 0)) || reload){
            dispatch(setFetchingStateGroup({fetchingSpecificGroups: true}));
             try {
                axios({
                    method: "GET",
                    url: `${process.env.REACT_APP_BACKEND_API}/group`,
                    headers: {
                        Accept: "application/json",
                        userId: userInfo.userId,
                        tenantId: localStorage.getItem("tenantId"),
                    },
                    params: {
                        spaceId,
                    },
                })
                .then(response => {
                    if(response.data){
                        return dispatch(loadSpaceSpecificGroups({data: response.data?.result}));
                    }
                })
            } catch (error) {
            }
        }
    };
}

export const fetchSpaceSpecificUserPickers = (data={}, reload=false ) => {
    return (dispatch, getState) => {
        const { spaceId, userInfo } = data
        
        // Validate spaceId before making API call
        if (!spaceId || spaceId === 'undefined' || spaceId === undefined) {
            return dispatch(loadSpaceSpecificUserPickers({data: []}));
        }
        
        const state = getState()
        const { userRoleGroupState } = state;
        if((userRoleGroupState && !userRoleGroupState.fetchingSpecificUserPickers && (!userRoleGroupState.spaceSpecificUserPickers || userRoleGroupState.spaceSpecificUserPickers.length === 0)) || reload){
            dispatch(setFetchingStateUserPicker({fetchingSpecificUserPickers: true}));
             try {
                axios({
                    method: "GET",
                    url: `${process.env.REACT_APP_BACKEND_API}/definedWidgets/${spaceId}`,
                    headers: {
                        Accept: "application/json",
                        userId: userInfo.userId,
                        tenantId: localStorage.getItem("tenantId"),
                    },
                    params: {
                        spaceId,
                    },
                })
                .then(response => {
                    if(response.data){
                        let userPickers = []
                        let userWidgets = response.data?.result || []
                        let reqDefinedWidgets = userWidgets.filter(widget => widget.isUserWidget)
                        userWidgets.forEach(widget => {
                            if(widget.children){
                                reqDefinedWidgets = reqDefinedWidgets.concat(widget.children.filter(wid => wid.isUserWidget))
                            }
                        })
                        reqDefinedWidgets = [...new Map(reqDefinedWidgets.map(item => [item["id"], item])).values()]
                        userPickers  = reqDefinedWidgets.map(picker => {
                            return {...picker, label: picker.label, value: picker.widgetId}
                        })
                        return dispatch(loadSpaceSpecificUserPickers({data: userPickers}));
                    }
                })
            } catch (error) {
            }
        }
    };
}